import { PropsWithChildren } from "react";
import { Modal } from "react-native";

export default function PortalMobile({ children }: PropsWithChildren) {
  return (
    <Modal visible transparent>
      {children}
    </Modal>
  );
}
